import { BlablacarThemeProvider } from "@obs/base";
import { ResetCSS, BlablacarThemeProvider as LegacyBlablacarThemeProvider } from "@obs/components";
import { IntlProvider } from "react-intl";

import { GoogleTagManager } from "./Components/GoogleTagManager";
import { primaryLocale } from "./Components/Settings/settingsState";
import { getMessages } from "./intl/getMessages";
import { Router } from "./Router";

export const App = () => {
	return (
		<IntlProvider messages={getMessages(primaryLocale.value)} locale={primaryLocale.value}>
			<LegacyBlablacarThemeProvider>
				<BlablacarThemeProvider>
					<GoogleTagManager />
					<ResetCSS />
					<Router />
				</BlablacarThemeProvider>
			</LegacyBlablacarThemeProvider>
		</IntlProvider>
	);
};
